export default {
  head: {
    ClientAdmin: '商户管理',
    ClientLIst: '商户列表'
  },
  table: {
    addClient: '新增商户',
    agentAccount: '代理账号',
    GeneralAgent: '总代理人',
    merchantModel: '商户模式',
    merchantName: '商户名称',
    merchantPhone: '商户手机号',
    MerchantBalance: '商户余额',

    merchantEmail: '商户邮箱',

    merchantNo: '商户号',
    merchantResources: '商户资源',
    merchantType: '商户类型',
    merchantStatus: '商户状态',
    autoTransIn: '自动转入',
    operaTion: '操作',
    changemessage: '修改商户信息',
    checkmessage: '查看商户信息',
    payoutQueryUrl: '代付反查地址',
    payoutQueryStatus: '代付反查状态'
  },
  addDialog: {
    addmerchant: '新增商户',
    userPass: '登录密码',
    payPass: '支付密钥',
    googleCode: '谷歌密钥',
    googleQrCode: '谷歌二维码',
    phone: '手机号',
    optionModtext1: '会员承担',
    optionModtext2: '商户承担',
    optionRestext1: '我们提供',
    optionRestext2: '商户提供',
    optionTypetext1: '总代',
    optionTypetext2: '代理',
    optionTypetext3: '商户',
    optionTypetext4: '商户子账号',
    optionTypetext5: '公司管理员',
    optionWithdratext1: '每笔提现金额的比例',
    optionWithdratext2: '每笔下发固定扣除',
    placeholdertext: '请输入内容',
    placeholderName: '请输入商户名称',
    selectModel: '选择商户模式',
    selectResour: '选择商户资源',
    selectType: '选择商户类型',
    payoutType: '商户代付类型',
    specialPayout: '手动代付',
    normalPayout: '自动代付',
    resetGoogleCode: '重置谷歌秘钥',
    orderPrefix: '商户订单前缀',
    unlock: '解锁',
    payoutCheckType: '代付反查类型',
    payoutCheckService: '代付反查服务'
  },
  updataDia: {
    updatamerchantModel: '修改商户模式',
    updatamerchantResources: '修改商户资源',
    updatamerchantType: '修改商户类型',
    updatamerchantWithdrawalType: '修改商户体现手续费',
    wallet: '钱包类型',
    card: '充值卡手续费',
    merchantWithdrawalFee: '提现单笔手续费',
    merchantWithdrawalType: '商户提现手续费',
    momo: 'momo 手续费',
    momoIpay: 'momo 商户手续费',
    onlineBankingDirectConnect: '卡转卡手续费',
    onlineBankingQr: '网银扫码手续费',
    payOnBehalfOf: '代付手续费',
    viettelpay: 'viettelpay 手续费',
    zalo: 'zalo 手续费',
    vipQr: 'QRPro扫码手续费',
    usdt: 'USDT 手续费',
    checkName: '商户名称不能为空！',
    universal: '通用码手续费',
    bankTransfer: '网银卡转卡手续费',
    payoutFixedFee: '代付固定手续费',
    momoBank: 'MomoBank 手续费',
    zaloBank: 'zaloBank 手续费',
    vtpBank: 'vtpBank 手续费'
  },

  label: {
    card: '充值卡手续费',
    merchantWithdrawalFee: '提现手续费数值',
    momo: 'Momo 个人手续费',
    momoIpay: 'Momo 商户手续费',
    onlineBankingDirectConnect: '卡转卡手续费',
    onlineBankingQr: '网银扫码手续费',
    payOnBehalfOf: '代付手续费',
    viettelpay: 'Viettel 手续费',
    zalo: 'ZALO 手续费',
    usdt: 'USDT 手续费',
    vipQr: 'QRPro扫码手续费',
    universal: '通用码手续费',
    bankTransfer: '网银卡转卡手续费',
    payoutFixedFee: '代付固定手续费',
    momoBank: 'MomoBank 手续费',
    zaloBank: 'zaloBank 手续费',
    vtpBank: 'vtpBank 手续费'
  },

  placeholder: {
    card: '请输入充值卡手续费',
    merchantWithdrawalFee: '请输入提现手续费数值',
    momo: '请输入momo 个人手续费',
    momoIpay: '请输入momo 商户手续费',
    onlineBankingDirectConnect: '请输入网银直连手续费',
    onlineBankingQr: '请输入网银扫码手续费',
    payOnBehalfOf: '请输入代付手续费',
    viettelpay: '请输入viettelpay 手续费',
    zalo: '请输入zalo 手续费',
    usdt: '请输入usdt 手续费',
    vipQr: '请输入QRPro扫码手续费',
    universal: '请输入通用码手续费',
    bankTransfer: '请输入网银卡转卡手续费',
    payoutFixedFee: '请输入代付固定手续费',
    momoBank: '请输入momoBank 手续费',
    zaloBank: '请输入zaloBank 手续费',
    vtpBank: '请输入vtpBank 手续费'
  },

  rules: {
    payoutQueryStatus: {
      required: '代付查询状态必须选择'
    },
    merchantType: {
      required: '商户类型必须选择'
    },
    agentAcct: {
      required: '代理账号必须选择'
    },
    merchantModel: {
      required: '商户模式必须选择'
    },
    merchantResources: {
      required: '商户资源必须选择'
    },
    merchantWithdrawalType: {
      required: '商户提现手续费必须选择'
    },
    payPass: {
      required: '支付密码不能为空',
      between: '支付密码必须大于6位小于等于20位'
    },
    card: {
      required: '充值卡手续费不能为空',
      type: '充值卡手续费必须为数字',
      min: '充值卡手续费必须大于0',
      max: '充值卡手续费必须小于等于100',
      float: '充值卡手续费最多能有两位小数'
    },
    merchantWithdrawalFee: {
      required: '提现手续费数值不能为空',
      type: '提现手续费数值必须为数字',
      min: '提现手续费数值必须大于等于0',
      max: '提现手续费数值必须小于等于100',
      float: '提现手续费数值最多能有两位小数'
    },
    momo: {
      required: 'momo 个人手续费不能为空',
      type: 'momo 个人手续费必须为数字',
      min: 'momo 个人手续费必须大于0',
      max: 'momo 个人手续费必须小于等于100',
      float: 'momo 个人手续费最多能有两位小数'
    },
    momoIpay: {
      required: 'momo 商户手续费不能为空',
      type: 'momo 商户手续费必须为数字',
      min: 'momo 商户手续费必须大于0',
      max: 'momo 商户手续费必须小于等于100',
      float: 'momo 商户手续费最多能有两位小数'
    },
    qrPro: {
      required: 'qrPro 个人手续费不能为空',
      type: 'qrPro 个人手续费必须为数字',
      min: 'qrPro 个人手续费必须大于0',
      max: 'qrPro 个人手续费必须小于等于100',
      float: 'qrPro 个人手续费最多能有两位小数'
    },
    onlineBankingDirectConnect: {
      required: '网银直连手续费不能为空',
      type: '网银直连手续费必须为数字',
      min: '网银直连手续费必须大于0',
      max: '网银直连手续费必须小于等于100',
      float: '网银直连手续费最多能有两位小数'
    },
    onlineBankingQr: {
      required: '网银扫码手续费不能为空',
      type: '网银扫码手续费必须为数字',
      min: '网银扫码手续费必须大于0',
      max: '网银扫码手续费必须小于等于100',
      float: '网银扫码手续费最多能有两位小数'
    },
    payOnBehalfOf: {
      required: '代付手续费不能为空',
      type: '代付手续费必须为数字',
      min: '代付手续费必须大于0',
      max: '代付手续费必须小于等于100',
      float: '代付手续费最多能有两位小数'
    },
    viettelpay: {
      required: 'viettelpay 手续费不能为空',
      type: 'viettelpay 手续费必须为数字',
      min: 'viettelpay 手续费必须大于0',
      max: 'viettelpay 手续费必须小于等于100',
      float: 'viettelpay 手续费最多能有两位小数'
    },
    zalo: {
      required: 'zalo 手续费不能为空',
      type: 'zalo 手续费必须为数字',
      min: 'zalo 手续费必须大于0',
      max: 'zalo 手续费必须小于等于100',
      float: 'zalo 手续费最多能有两位小数'
    },
    usdt: {
      required: 'usdt 手续费不能为空',
      type: 'usdt 手续费必须为数字',
      min: 'usdt 手续费必须大于0',
      max: 'usdt 手续费必须小于等于100',
      float: 'usdt 手续费最多能有两位小数'
    },
    universal: {
      required: 'universal 手续费不能为空',
      type: 'universal 手续费必须为数字',
      min: 'universal 手续费必须大于0',
      max: 'universal 手续费必须小于等于100',
      float: 'universal 手续费最多能有两位小数'
    },
    bankTransfer: {
      required: 'bankTransfer 手续费不能为空',
      type: 'bankTransfer 手续费必须为数字',
      min: 'bankTransfer 手续费必须大于0',
      max: 'bankTransfer 手续费必须小于等于100',
      float: 'bankTransfer 手续费最多能有两位小数'
    },
    payoutFixedFee: {
      required: '代付固定手续费不能为空'
    },
    momoBank: {
      required: 'momoBank 手续费不能为空',
      type: 'momoBank 手续费必须为数字',
      min: 'momoBank 手续费必须大于0',
      max: 'momoBank 手续费必须小于等于100',
      float: 'momoBank 手续费最多能有两位小数'
    },
    zaloBank: {
      required: 'zaloBank 手续费不能为空',
      type: 'zaloBank 手续费必须为数字',
      min: 'zaloBank 手续费必须大于0',
      max: 'zaloBank 手续费必须小于等于100',
      float: 'zaloBank 手续费最多能有两位小数'
    },
    vtpBank: {
      required: 'vtpBank 手续费不能为空',
      type: 'vtpBank 手续费必须为数字',
      min: 'vtpBank 手续费必须大于0',
      max: 'vtpBank 手续费必须小于等于100',
      float: 'vtpBank 手续费最多能有两位小数'
    }
  },
  Minimum_safety_limit_for_merchant_payment: '商户代付最低安全限额',
  Please_enter_the_minimum_security_limit_for_merchant_payment: '请输入商户代付最低安全限额',
  Payment_warning_group_id: '代付警告群组ID',
  Please_enter_the_payment_warning_group_id: '请输入代付警告群组ID',
  Merchant_Withdrawal_Minimum_Security_Limit: '商户提款最低安全限额',
  Please_enter_the_merchant_minimum_security_limit_for_withdrawals: '请输入商户提款最低安全限额',
  Withdrawal_warning_group_ID: '提款警告群组ID',
  Please_enter_the_withdrawal_warning_group_ID: '请输入提款警告群组ID',
  CannotEmpty: '不能为空'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/clientmanage.js